import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

export const TimeZoneProp = ImmutablePropTypes.mapContains({
    city: PropTypes.string.isRequired,
    zoneName: PropTypes.string.isRequired,
    zoneAbbr: PropTypes.string.isRequired
});
